module.exports = __webpack_public_path__ + "static/media/mockup.519d657c.png";